function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { createContext, memo, useContext } from 'react';
import { FormProvider, useFormGenericSetStateMethods } from 'formydable';
const FormManagerContext = /*#__PURE__*/createContext(null);
export const useFormManager = () => useContext(FormManagerContext);
const Form = /*#__PURE__*/memo(({
  value,
  onSubmit,
  children,
  readonly,
  stripped,
  ...props
}) => {
  const {
    store
  } = value;
  const {
    formSubmit
  } = useFormGenericSetStateMethods(store);
  const handleSubmit = formSubmit(readonly ? () => {} : onSubmit);
  return /*#__PURE__*/React.createElement(FormManagerContext.Provider, {
    value: {
      readonly,
      onSubmit: handleSubmit
    }
  }, /*#__PURE__*/React.createElement(FormProvider, {
    value: store
  }, stripped ? children : /*#__PURE__*/React.createElement("form", _extends({
    role: "form",
    onSubmit: handleSubmit
  }, props), children)));
});
export default Form;